import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'wl-busy',
  templateUrl: 'busy-indicator.component.html',
  styleUrls: ['busy-indicator.component.css'],
    standalone: false
})
export class BusyIndicatorComponent {
  @Input() show: boolean = false;
  @Input() isLarge: boolean = false;
  public constructor() {
    this.show = false;
  }
}
